import { Suspense } from 'react'
import { RightBarContainerAsync } from './RightbarContainerAsync'

export const RightBar = () => {
    return (
        <Suspense fallback={'Loading...'}>
            <RightBarContainerAsync />
        </Suspense>
    )
}